import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import MessageTableHead from '../../components/molecules/MessageTableHead';
import MessageTableBody from '../../components/molecules/MessageTableBody';
import TablePagination from '../../components/molecules/TablePagination';
import ConfirmDialog from '../../components/molecules/ConfirmDialog';
import { sendLogin } from '../../auth/Auth';

const styles = {
  scrollTable: {
    maxHeight: 435,
    overflowX: 'scroll',
    whiteSpace: 'nowrap'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(state => ({
    name: state.loginInfo.name,
    messages: state.messages.messages
  })),
  setPropTypes(propTypes),
  withState('openDrawer', 'updateOpenDrawer', false),
  withState('openConfirm', 'updateOpenConfirm', false),
  withState('rowsPerPage', 'setRowsPerPage', 100),
  withState('order', 'setOrder', 'asc'),
  withState('orderBy', 'setOrderBy', 'messageId'),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    },
    handleChangeRowsPerPage: props => (event, rowsPerPage) => {
      props.setRowsPerPage(rowsPerPage);
    },
    handleRequestSort: props => property => {
      const isDesc = props.orderBy === property && props.order === 'desc';
      props.setOrder(isDesc ? 'asc' : 'desc');
      props.setOrderBy(property);
    }
  }),
  lifecycle({
    componentDidMount() {}
  })
);

const Main = enhance(
  ({
    classes,
    page,
    handleChangePage,
    messages,
    openConfirm,
    updateOpenConfirm,
    rowsPerPage,
    order,
    orderBy,
    handleChangeRowsPerPage,
    handleRequestSort
  }) => {
    const emptyRows =
      rowsPerPage - Math.min(rowsPerPage, messages.length - page * rowsPerPage);
    const okAction = () => {
      updateOpenConfirm(false);
    };
    return (
      <div>
        <div className={classes.scrollTable} id="scrollTableId">
          <Table stickyHeader>
            <MessageTableHead
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
            />
            <MessageTableBody
              messages={messages}
              emptyRows={emptyRows}
              page={page}
              rowsPerPage={rowsPerPage}
              updateOpenConfirm={updateOpenConfirm}
              order={order}
              orderBy={orderBy}
            />
          </Table>
        </div>
        <div>
          <TablePagination
            searchResults={messages}
            rowsPerPage={rowsPerPage}
            page={page}
            handleChangePage={handleChangePage}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
          />
        </div>
        <ConfirmDialog
          openConfirm={openConfirm}
          updateOpenConfirm={updateOpenConfirm}
          okAction={okAction}
          message="非表示に切りかえます。よろしいですか？"
        />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
